export default {
  SET_CLIENT_LIST(state, clientList) {
    state.clientList = clientList;
  },
  RESET_CLIENT_LIST(state) {
    state.clientList = [];
  },
};
